/**
 * 📐 PAGE LAYOUT CONSTANTS - CHILDREN WEB APP (2025 MULTI-DEVICE STANDARD)
 *
 * Master dimensions en Full HD pour compatibilité maximale multi-device
 * Display mode: cover partout
 * Safe zones centrales pour contenu critique
 * Syncronisé avec /admin/src/constants/pageConstants.ts
 */

// Dimensions MASTER pour paysage (Landscape) - 16:9
export const PAGE_DIMENSIONS_LANDSCAPE = {
  WIDTH: 1920,   // Full HD pour performance
  HEIGHT: 1080,  // Ratio 16:9 (1920/1080 = 1.78)
  ASPECT_RATIO: 16/9,

  // Safe zone 4:3 (zone carrée centrale pour contenu critique)
  SAFE_ZONE: {
    WIDTH: 1440,   // 1080 * 4/3 = 1440
    HEIGHT: 1080,
    X: 240,        // (1920 - 1440) / 2 = 240
    Y: 0,
  }
} as const;

// Dimensions MASTER pour portrait (Portrait) - 9:16
export const PAGE_DIMENSIONS_PORTRAIT = {
  WIDTH: 1080,   // Full HD
  HEIGHT: 1920,  // Ratio 9:16 (1080/1920 = 0.56)
  ASPECT_RATIO: 9/16,

  // Safe zone 3:4 (zone carrée centrale pour contenu critique)
  SAFE_ZONE: {
    WIDTH: 1080,
    HEIGHT: 1440,  // 1080 * 4/3 = 1440
    X: 0,
    Y: 240,        // (1920 - 1440) / 2 = 240
  }
} as const;

// Dimensions par défaut (landscape pour compatibilité)
export const PAGE_DIMENSIONS = {
  ...PAGE_DIMENSIONS_LANDSCAPE,

  // Dimensions par défaut des éléments
  DEFAULT_TEXT_WIDTH: 200,
  DEFAULT_TEXT_HEIGHT: 100,
  DEFAULT_BUBBLE_WIDTH: 250,
  DEFAULT_BUBBLE_HEIGHT: 120,
  DEFAULT_CHOICE_BUTTON_WIDTH: 200,
  DEFAULT_CHOICE_BUTTON_HEIGHT: 60,

  // Marges et espacements
  PADDING: 20,
  CHOICE_SPACING: 10,
} as const;

/**
 * Retourne les dimensions du canevas selon l'orientation
 * @param orientation - 'landscape' ou 'portrait'
 * @returns { WIDTH, HEIGHT, ASPECT_RATIO, SAFE_ZONE }
 */
export function getPageDimensions(orientation?: 'landscape' | 'portrait') {
  return orientation === 'portrait' ? PAGE_DIMENSIONS_PORTRAIT : PAGE_DIMENSIONS_LANDSCAPE;
}

export const CHOICE_BUTTON_STYLE = {
  backgroundColor: 'linear-gradient(135deg, #3B82F6, #8B5CF6)',
  color: '#ffffff',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: 'bold',
  padding: '12px 20px',
  border: 'none',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.2s ease',
} as const;